import styled, { css } from "styled-components";
import { pageGutterSpace } from "../../../../../../../settings";
import pageHeaderBrandStyles from "../../../../../../../theme/pageHeaderBrandStyles";
import breakpoint from "../../../../../../../utils/breakpoint";
import getColor from "../../../../../../../utils/getColor";
import space from "../../../../../../../utils/space";
import transition from "../../../../../../../utils/transition";
import unit from "../../../../../../../utils/unit";
import { hugeBreakpointValue } from "../../../settings";
import { slowAnimationTime } from "../NavigationOrg.settings";

// eslint-disable-next-line import/prefer-default-export
export var NavigationList = styled.ul.withConfig({
  componentId: "sc-19a787y-0"
})(function (_ref) {
  var $brand = _ref.$brand,
    $markerLeftPosition = _ref.$markerLeftPosition,
    $background = _ref.$background,
    theme = _ref.theme;
  return css(["padding:0 ", ";", "{height:100%;overflow:auto;background:", ";}", "{display:flex;position:relative;height:100%;padding:0;&::after{content:\"\";position:absolute;bottom:0;width:", ";height:", ";opacity:0;background:", ";}", "}> li{margin-bottom:", ";&:last-child{margin-bottom:0;}", "{margin-bottom:0;> *{height:100%;}button,a{outline-offset:-", ";}}}"], space(pageGutterSpace), breakpoint("small", hugeBreakpointValue), getColor(theme, $background), breakpoint(hugeBreakpointValue), space(3), unit(2), getColor(theme, pageHeaderBrandStyles[$brand].navigationListMarkerColor), $markerLeftPosition && css(["&::after{", ";left:", "px;opacity:1;}"], transition("left ".concat(slowAnimationTime, " cubic-bezier(0,.8,0,1)"), "opacity"), $markerLeftPosition), space(1), breakpoint(hugeBreakpointValue), unit(2));
});
export var BackLinkLi = styled.li.withConfig({
  componentId: "sc-19a787y-1"
})(["> *{padding:", " 0;}"], space(2));